import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react'
import FormCreator from '../../../components/Forms/FormCreator';
import { RejectReasonData } from '../data/RejectReasonData';
import Buttons from '../../../components/ui/button/Buttons';

const RejectReason = forwardRef((props, ref) => {
  const [rejectReasonForm, SetrejectReasonForm] = useState(RejectReasonData);

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const data = ref.current.getFormData();
        return data;
      }
      return null;
    }
  }));


  const handleSubmit = () => {
    const data = ref.current.getFormData();
    if(data != ""){
      props.handleReject()
    }
  }

  return (
    <div>
      <div className='row'>
        <div className='reaject-application-main'>
          <div className='row'>
            <FormCreator ref={ref} {...rejectReasonForm} />
          </div>
          <div className='d-flex justify-content-center mt-3'>
            <Buttons
              buttonText="Submit"
              buttonTypeClassName="success-btn"
              onClick={handleSubmit}
              isLoading={props.isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  )
})

export default RejectReason